import instantsearch from 'instantsearch.js';
import { configure, searchBox, hits } from 'instantsearch.js/es/widgets';
import { getAlgoliaSearchClient } from './algolia-helpers';

const searchClient = getAlgoliaSearchClient();
const indexName = `${window.algolia.prefix}_mckinnon`;
const search = instantsearch({
    indexName,
    searchClient,
    searchFunction(helper) {
        if (helper.state.query) {
            document.getElementById('header-search-init').style.display = 'none';
            document.getElementById('top3').style.display = 'flex';
            document.getElementById('see-all-results').href = `/search/?query=${helper.state.query}`;
            helper.search();
        } else {
            document.getElementById('header-search-init').style.display = 'block';
            document.getElementById('top3').style.display = 'none';
            document.getElementById('see-all-results').setAttribute('style', 'display:none !important');
        }
    },
    searchParameters: {
        hitsPerPage: 3,
        filters: 'status:live OR status:enabled',
    },
    routing: true,
});

search.addWidgets([
    configure({
        analytics: true,
        clickAnalytics: true,
    }),

    searchBox({
        container: '#search-box',
        placeholder: 'Search',
        showReset: false,
        cssClasses: {
            submitIcon: 'submit',
        },
    }),

    hits({
        container: '#top3',
        templates: {
            item: `
                <a
                    href="{{ uri }}"
                    onclick="if (!window.internalIPs.includes(window.userIP)) window.aa('clickedObjectIDsAfterSearch', {
                        index: '${indexName}',
                        eventName: 'Search Result Clicked',
                        objectIDs: ['{{ objectID }}'],
                        queryID: '{{ __queryID }}',
                        positions: [{{ __position }}],
                    });"
                >
                    <figure>
                        <img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" srcset="{{ image1x }} 1x, {{ image2x }} 2x" alt="" />
                    </figure>
                    <div class="type">{{ type }}</div>
                    <h2>{{#helpers.highlight}}{ "attribute": "title" }{{/helpers.highlight}}</h2>
                    <p class="view">View Details <img src="/assets/images/icon-arrow-right.svg" width="7" height="11" alt=""></p>
                </a>
            `,
            empty: 'Sorry, your search returned no results.',
        },
        transformItems(items) {
            return items.map(item => {
                if (item.type === 'Textiles Variant') {
                    item._highlightResult.title.value = `${item.product_title}: ${item._highlightResult.title.value}`;
                    item.type = 'Textiles';
                }
                return item;
            });
        },
        cssClasses: {
            list: ['search-results-list'],
            item: ['search-results', 'result'],
        },
    }),
]);

search.start();

search.helper.on('result', function(helper) {
    if (helper.nbHits < 3) {
        document.getElementById('see-all-results').setAttribute('style', 'display:none !important');
    } else {
        document.getElementById('see-all-results').setAttribute('style', 'display: block !important');
    }
});

function resetSearch() {
    search.helper.setQuery('');
    document.getElementsByClassName('ais-SearchBox-input')[0].value = '';
    document.getElementById('see-all-results').setAttribute('style', 'display:none !important');
    document.getElementById('top3').style.display = 'none';
}

document.getElementsByClassName('escape')[0].addEventListener('click', function() {
    resetSearch();
});

document.onkeypress = function(e) {
    if (e.keyCode === 27) {
        resetSearch();
    }
};
